import { createSelector } from '@reduxjs/toolkit';
import { preferencesSelectors } from 'app-components/flux/preferences';
import store from 'app-components/utils/redux-store';
import { LruObjectCache, createCachedSelector } from 're-reselect';
import createTheme from './createTheme';

export const getThemeByKey = createCachedSelector(
  (themeKey) => themeKey || '',
  (themeKey) => {
    const mode = !themeKey || themeKey === 'muiDefault' || themeKey === 'simplifiDefault' ? 'light' : 'dark';
    return createTheme(mode);
  },
)({
  keySelector: (themeKey) => themeKey || '',
  cacheObject: new LruObjectCache({ cacheSize: 5 }),
});

export const getCurrentTheme = createSelector(
  (state) =>
    (preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] }) || {}).theme,
  (themeKey) => getThemeByKey(themeKey),
);

export const getThemeMode = (state) => {
  const themeKey = (
    preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] }) || {}
  ).theme;
  return !themeKey || themeKey === 'muiDefault' || themeKey === 'simplifiDefault' ? 'light' : 'dark';
};

// don't use this method, unless you know what you are doing
export const dangerouslyGetTheme = () => {
  const state = store.getState();
  const datasetPreferences =
    state && preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] });
  const themeKey = datasetPreferences && datasetPreferences.theme;
  return getThemeByKey(themeKey);
};
